import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTeacherSlots } from "../../../services/teacher";
import { reactToast } from "../../../helper";

export const getTeacherSlots = createAsyncThunk(
  "slots/fetchContent",
  async ({ teacherId, payload }) => {
    try {
      const { status, data } = await fetchTeacherSlots(teacherId, payload);
      if (status === 200) {
        return data?.data;
      } else {
        reactToast("error", data?.message);
      }
    } catch (error) {}
  }
);
